"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyHodOnboardingStepId = exports.HodOnboardingStepId = void 0;
const CommonOnboardingStepId_1 = require("../../common/domain/CommonOnboardingStepId");
var HodOnboardingStepId;
(function (HodOnboardingStepId) {
    /**
     * Step where the user fills in information that will later be used for matching algorithms.
     */
    HodOnboardingStepId["HOD_MATCHING"] = "HOD_MATCHING";
    /**
     * Step where the user is informed about the activities of a Host on Demand.
     */
    HodOnboardingStepId["HOD_GET_TO_KNOW_US"] = "HOD_GET_TO_KNOW_US";
    /**
     * Step where the user must provide administrative documents in order to carry out the Host on Demand activity.
     */
    HodOnboardingStepId["HOD_ADMINISTRATIVE_DOCS"] = "HOD_ADMINISTRATIVE_DOCS";
    /**
     * Step where the user enters his availability for an online meeting with Leavy.
     */
    HodOnboardingStepId["HOD_MEETING"] = "HOD_MEETING";
})(HodOnboardingStepId = exports.HodOnboardingStepId || (exports.HodOnboardingStepId = {}));
exports.AnyHodOnboardingStepId = Object.assign({}, CommonOnboardingStepId_1.CommonOnboardingStepId, HodOnboardingStepId);
//# sourceMappingURL=HodOnboardingStepId.js.map